"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when a user info could not be found
 * @param {string} field the field that failed validation
 * @param {string} id the id that was not found
 */
class UserInfoDoesNotExistError extends client_library_1.ExtendableError {
    constructor(field, id) {
        super(`user info: not found with ${field} ${id}.`);
    }
}
exports.default = UserInfoDoesNotExistError;
//# sourceMappingURL=UserInfoDoesNotExistError.js.map